<script>
  // @ts-check
  import Grid from "../atoms/Grid.svelte";
  import GridContainer from "../atoms/GridContainer.svelte";
  import WordCloud from "../molecules/WordCloud.svelte";

  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;

  /**
   * List of content items to be displayed in the word cloud. Each item is an object with a `type` property
   * that can be either "text" or "image", and a `content` property that is either the text to be displayed
   * or the URL of the image to be displayed.
   * @type {Array<{type: string, content: string}>}
   */
  export let titleContentList;

  /**
   * The optional description body of the component
   * @type {string}
   */
  export let description = null;

  /**
   * The optional disclaimer body of the component
   * @type {string}
   */
  export let disclaimer = null;
</script>

<GridContainer containerClass="py-15 md:py-20 lg:py-30 xl:py-40" {id}>
  <Grid>
    <div class="col-full-width flex flex-col md:col-span-6 lg:col-start-2">
      <div class="pb-5 uppercase">
        <slot name="title">
          <WordCloud contentList={titleContentList} />
        </slot>
      </div>
      <div class="body-sm pt-5">
        <slot name="description">
          {#if description}
            <p>
              {description}
            </p>
          {/if}
        </slot>
      </div>
      <div class="label pt-5 opacity-black-60">
        <slot name="disclaimer">
          {#if disclaimer}
            <p>
              {disclaimer}
            </p>
          {/if}
        </slot>
      </div>
    </div>
    <div class="col-full-width flex flex-col pt-15 md:col-span-6 md:pt-0 lg:col-span-4">
      <slot name="embed" />
    </div>
  </Grid>
</GridContainer>
